import React from "react";
var __jsx = React.createElement;
import { useLang } from "@/common/Contexts/LanguageContext";
import { getFinancingFAQs } from "@/pages/financing/FinancingFAQ/financingFaqData";
import BrandCommonQuestion from "@/components/SearchComponent/SEOAboutSection/BrandCommonQuestion";
var FinancingFAQ = function FinancingFAQ(_ref) {
  var make = _ref.make,
    model = _ref.model,
    cheapestCarPriceDetails = _ref.cheapestCarPriceDetails;
  var lang = useLang();
  var faqs = getFinancingFAQs({
    make: make,
    model: model,
    cheapestCarPriceDetails: cheapestCarPriceDetails,
    lang: lang
  });
  if (!faqs.length) return null;
  var faqQuestions = faqs.map(function (faq) {
    return {
      question_ar: lang === 'ar' ? faq.question : faq.question,
      question_en: lang === 'en' ? faq.question : faq.question,
      answer_ar: lang === 'ar' ? faq.answer : faq.answer,
      answer_en: lang === 'en' ? faq.answer : faq.answer
    };
  });
  var title = lang === 'ar' ? 'الأسئلة الشائعة' : 'FAQs';
  return /*#__PURE__*/React.createElement("div", {
    className: "container py-8"
  }, /*#__PURE__*/React.createElement(BrandCommonQuestion, {
    title: title,
    questions: faqQuestions
  }));
};
export default FinancingFAQ;